import React from 'react'

const PublicAndPopularBoardDetails = () => {
  return (
    <div>PublicAndPopularBoardDetails</div>
  )
}

export default PublicAndPopularBoardDetails